<div class="my__lead__list__layout">
  <div class="my__lead__list__layout__list">
    <header class="my__lead__list__layout__list__header">
      <ng-container [ngTemplateOutlet]="list.customTitle?.templateRef || defaultTitle"></ng-container>
      <ng-container [ngTemplateOutlet]="list.customHeader?.templateRef ?? null"></ng-container>
    </header>
    <div class="my__lead__list__layout__list__content">
      <ng-container [ngTemplateOutlet]="list.content?.templateRef ?? null"> </ng-container>
    </div>
    <div class="my__lead__list__layout__list__footer">
      <ng-container [ngTemplateOutlet]="list.footer?.templateRef ?? null"> </ng-container>
    </div>
  </div>
  <div class="my__lead__list__layout__sidebar" [ngClass]="{'show': showSidebar, 'hide': !showSidebar && showSidebar !== undefined}">
    <ng-container [ngTemplateOutlet]="sidebar.content?.templateRef ?? null"> </ng-container>
    <button *ngIf="showSidebar" class="btn sidebar__button__close" (click)="showSidebar = false">
      <nb-icon icon="cross" pack="icomoon" class="cross-icon"></nb-icon>
    </button>
  </div>
  <button (click)="showSidebar = true" class="btn sidebar__button">
    <nb-icon [icon]="sidebar.sidebarIcon" pack="icomoon"></nb-icon>
  </button>
  <div class="overlay" *ngIf="showSidebar" (click)="showSidebar = false"></div>
</div>

<ng-template #defaultTitle>
  <div class="title">
    <nb-icon [icon]="list.headerIcon" pack="icomoon"></nb-icon>
    <p>{{ list.header }}</p>
    <span class="count">({{ list.itemsCount }})</span>
  </div>
</ng-template>
